import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const DcViewSingle = () => {
  useAuthRedirect();
    const {dcNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);

  const canView  = hasPermission("Delivery challan", "view");


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/dc_detailsHeader?dcNo=${dcNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                dcNumber: items[0].dcheader_number,
                branch: items[0].branchCode,
                dcDate: items[0].dcheader_date,
                type: items[0].dcheader_type,
                scode: items[0].dcheader_supplierCode,
                sName: items[0].dcheader_supplierName,
                refNo: items[0].dcheader_yourReferenceNumber,
                refDate: items[0].dcheader_yourReferenceDate,
                pack: items[0].dcheader_noofPacks,
                vno: items[0].dcheader_vehicleNumber,
                remarks: items[0].dcheader_remarks,
                address: items[0].dcheader_address,
                city: items[0].dcheader_city,
                pincode: items[0].dcheader_pincode,
                phone: items[0].dcheader_phone,
                email: items[0].dcheader_mobile,
            };

            setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [dcNo, branch]); 

 const [loading, setLoading] = useState(true);

useEffect(() => {
  setLoading(true); // start loading before fetching
  axios
    .get(`https://rfs2.infraconsoft.net.in/api/dc_bottomDetails?dcNo=${dcNo}&branch=${branch}`)
    .then((response) => {
      setData(response.data.bottomDetails || []);
    })
    .catch((error) => {
      console.error("Error fetching vehicles:", error);
    })
    .finally(() => {
      setLoading(false); // stop loading after fetch
    });
}, [dcNo, branch]);


  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                              <h2 className="add-txt">Delivery Challan - View</h2>
                              <Link to='/inventory/dcView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                              </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>D.C No :</label>
                <input type="text" name="indentNo" value={header.dcNumber} readOnly/>

              </div>
              <div className="form-group">
                <label>Date :</label>
<input
  type="date"
  value={
    header.dcDate && !isNaN(Date.parse(header.dcDate))
      ? new Date(header.dcDate).toISOString().split("T")[0]
      : ""
  }
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Type :</label>
                <input type="text" name="type" value={header.type} readOnly />
              </div>
              <div className="form-group">
                <label>Branch :</label>
                <input type="text" name="branch" value={header.branch} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" value={header.scode} readOnly/>
              </div>

              <div className="form-group">
                <label>Supplier Name:</label>
                <input type="text"value={header.sName} readOnly />
              </div>
            </div>




            <div className="form-row">
              <div className="form-group">
                <label>Your Ref No :</label>
                <input type="text" value={header.refNo} readOnly/>
              </div>

              <div className="form-group">
                <label>Your Ref Date :</label>
                <input
  type="date"
  value={
    header.refDate && !isNaN(Date.parse(header.refDate))
      ? new Date(header.refDate).toISOString().split("T")[0]
      : ""
  }
  readOnly
/>

              
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle No :</label>
                <input type="text" value={header.vno} readOnly/>
              </div>

              <div className="form-group">
                <label>No.Of Packs:</label>
                <input type="text" value={header.pack} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address :</label>
                <input type="text" value={header.address} readOnly/>
              </div>

              <div className="form-group">
                <label>Email:</label>
                <input type="text" value={header.email} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" value={header.city} readOnly/>
              </div>

              <div className="form-group">
                <label>Pincode :</label>
                <input type="text" name="pincode"value={header.pincode} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone :</label>
                <input type="text" value={header.phone} readOnly/>
              </div>

              <div className="form-group">
                <label>Remarks :</label>
                <input type="text"value={header.remarks} readOnly />
              </div>
            </div>

            
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Closing Stock</th>
                    <th>D.C Qty</th>
                    <th>Due Date</th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" style={{ textAlign: "center", fontWeight: "bold" }}>
        Loading...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.dcdetail_itemcode}</td>
        <td>{item.dcdetail_ItemName}</td>
        <td>{item.dcdetail_uom}</td>
        <td>{item.itemmaster_closingStock}</td>
        <td>{item.dcdetail_quantity}</td>
        <td>{new Date(item.dcdetail_duedate).toLocaleDateString("en-GB")}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default DcViewSingle;
